import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { getAwards } from "../../api/award.api";
import { getUser } from "../../api/user.api";

const RevokeAwardModal = ({ open, handleClose, handleSubmit, user }) => {
  const [awards, setAwards] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    id: "",
  });

  const initialFormData = {
    name: "",
    id: "",
  };

  useEffect(() => {
    if (user) {
      getUser(user.id)
        .then((response) =>
          getAwards(response.data.awards).then((response) =>
            setAwards(response.data)
          )
        )
        .catch((error) => console.log(error));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Revoke Award</Typography>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-category-label">Award</InputLabel>
              <Select
                labelId="select-category-label"
                id="award"
                name="id"
                value={formData.id}
                label="Award"
                onChange={handleChange}
              >
                {awards.map((award) => (
                  <MenuItem key={award.id} value={award.id}>
                    {award.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Revoke
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RevokeAwardModal;
